// extracted by mini-css-extract-plugin
export default {"splashPage":"styles_splashPage__hXpr9","cargoToast":"styles_cargoToast__qI2SR"};